import CountUp from "react-countup";
import { motion } from "framer-motion";
import './cards.scss';

const StatsCard = ({ heading, icon, content }) => {
    return (
        <motion.div
            className="stats-card card text-center p-2 shadow-lg"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            whileHover={{ scale: 1.03 }}
        >
            <motion.div
                className="icon-circle mx-auto mb-3"
                initial={{ scale: 0, rotate: -90 }}
                animate={{ scale: 1, rotate: 0 }}
                transition={{ type: "spring", stiffness: 200, damping: 12 }}
                whileHover={{ rotate: [0, 10, -10, 0] }}
            >
                {icon}
            </motion.div>
            <div className="d-flex justify-content-center align-content-center ">
                <h6 className="text-info text-uppercase fw-bold me-4" style={{lineHeight:"35px"}}>{heading}</h6>
                <div className="stat-number display-6 fw-bold text-dark">
                    <CountUp end={content} duration={1.5} separator="," />
                </div>
            </div>
        </motion.div>
    );
};

export default StatsCard;
